'use strict';

function getSessionVariableKey(placeId) {
  return `mpp-request-a-deal-${placeId}`;
}

function removeFromStorage(placeId) {
  return typeof sessionStorage !== 'undefined' && sessionStorage !== null
    ? sessionStorage.removeItem(getSessionVariableKey(placeId))
    : undefined;
}

function getFromStorage(placeId) {
  return typeof sessionStorage !== 'undefined' && sessionStorage !== null
    ? sessionStorage.getItem(getSessionVariableKey(placeId))
    : undefined;
}

function setToStorage(placeId, value) {
  if (typeof sessionStorage !== 'undefined' && sessionStorage !== null) {
    return sessionStorage.setItem(getSessionVariableKey(placeId), value);
  }
  return null;
}

(function() {
  let enqueueCarouselItem;
  let dequeueVisibleItems;
  let markItemSelected;
  let scrollCarouselBack;
  let scrollCarouselForward;
  let decideCarouselScroll;
  const Cls = (Groupon.RequestDeal = class RequestDeal {
    static initClass() {
      enqueueCarouselItem = item => $(item).attr('visible', 'true');

      dequeueVisibleItems = carouselInstance =>
        _.each(carouselInstance.children(), carouselElement =>
          $(carouselElement).attr('visible', 'false')
        );

      markItemSelected = item => $(item).addClass('requested');

      scrollCarouselBack = function(carouselInstance, visibleCount) {
        dequeueVisibleItems(carouselInstance.list());
        return carouselInstance.scroll(`-=${visibleCount}`);
      };

      scrollCarouselForward = function(carouselInstance, visibleCount) {
        dequeueVisibleItems(carouselInstance.list());
        return carouselInstance.scroll(`+=${visibleCount}`);
      };

      decideCarouselScroll = function(carouselInstance, visibleCount) {
        const visibleAndUnchecked = carouselInstance
          .list()
          .find("li[visible='true']:not(.requested)");

        if (visibleAndUnchecked.length === 0) {
          return setTimeout(
            () => scrollCarouselForward(carouselInstance, visibleCount),
            400
          );
        }
        return null;
      };
    }

    constructor(el, csrf, placeId, nearbyPlacesCount, showModal) {
      this.el = el;
      this.csrf = csrf;
      this.placeId = placeId;
      this.nearbyPlacesCount = nearbyPlacesCount;
      this.showModal = showModal;
      this.$el = $(this.el);
      this.rootUrl = '/merchant-page';
      this.visibleCount = 3;
      this.$carousel = this.$el.find('.request-deal-nearby-carousel');
      this.$carouselPreviousButton = this.$el.find('.jcarousel-control-prev');
      this.$carouselNextButton = this.$el.find('.jcarousel-control-next');
      this.$carouselNotifyButton = this.$el.find('.carousel-notify-button');
      this.$requestADealButton = this.$el.find('#request-deal-btn');
      this.$loading = this.$el.find('.loading');
      this.$requestADealImageWrapper = this.$el.find(
        '.request-deal-image-wrapper'
      );
      this.$requestADealInfo = this.$el.find('.request-deal-info');
      this.$requestADealSubscribedWrapper = this.$el.find(
        '.subscribed-wrapper'
      );
      this.$requestADealNowFollowing = this.$el.find('.now-following');
      this.modalCreated = false;
      this.bindEventHandlers();
    }

    bindEventHandlers() {
      return $(document).ready(() => {
        const shouldOpenModal =
          this.nearbyPlacesCount >= this.visibleCount && this.showModal;
        this.$requestADealButton.click(() => {
          return this.sendDealRequest(this.placeId, shouldOpenModal);
        });

        if (getFromStorage(this.placeId) != null) {
          removeFromStorage(this.placeId);
          return this.sendDealRequest(this.placeId, shouldOpenModal, true);
        }
        return null;
      });
    }

    openModal() {
      MPP.Modal.open('#request-deal-nearby-places-modal');

      if (!this.modalCreated) {
        this.createNearbyCarousel();
        this.modalCreated = true;
        return this.modalCreated;
      }
      return null;
    }

    createNearbyCarousel() {
      this.$carousel.jcarousel({
        wrap: 'circular',
      });
      const carouselInstance = this.$carousel.data('jcarousel');
      this.$carouselPreviousButton.click(() =>
        scrollCarouselBack(carouselInstance, this.visibleCount)
      );
      this.$carouselNextButton.click(() =>
        scrollCarouselForward(carouselInstance, this.visibleCount)
      );
      this.$carousel.jcarousel().on('jcarousel:visiblein', 'li', function() {
        return enqueueCarouselItem(this);
      });
      this.$carouselNotifyButton.click(event => {
        event.preventDefault();
        const $clickedButton = $(event.target);
        const { placeId } = $clickedButton.data();
        const closestLi = $clickedButton.closest('li');
        this.sendDealRequest(placeId, false, false);
        markItemSelected(closestLi);
        decideCarouselScroll(carouselInstance, this.visibleCount);
        return $clickedButton.fadeOut(200);
      }); //# mark the first visibleCount items as visible

      _.each(
        carouselInstance
          .list()
          .children()
          .slice(0, this.visibleCount),
        visibleElement => enqueueCarouselItem(visibleElement)
      ); // if we have less than 4 nearby places, we can hide the carousel controls

      if (this.nearbyPlacesCount <= 3) {
        this.$carouselPreviousButton.hide();
        return this.$carouselNextButton.hide();
      }
      return null;
    }

    showLoading() {
      this.$requestADealButton.hide();
      return this.$loading.show();
    }

    hideLoading() {
      this.$loading.hide();
      return this.$requestADealButton.show();
    }

    sendDealRequest(placeId, openModal = false, triggeredOnPageLoad = false) {
      const obj = {
        _csrf: this.csrf,
        placeId,
        enabled: true,
        triggeredOnPageLoad,
      };
      this.showLoading();
      return $.ajax({
        url: `${this.rootUrl}/request-deal`,
        type: 'POST',
        contentType: 'application/json',
        dataType: 'json',
        data: JSON.stringify(obj),
        success: res => {
          this.hideLoading();

          if (MPP.JsonResponseHandler.loginRequired(res)) {
            return setToStorage(this.placeId, true);
          }

          if (res.result !== 'ok') {
            return null;
          }

          this.$requestADealImageWrapper.remove();
          this.$requestADealInfo.remove();
          this.$requestADealSubscribedWrapper.removeAttr('hidden');
          this.$requestADealNowFollowing.removeAttr('hidden');

          if (openModal) {
            this.openModal();
          } //# let the follow module know that a deal has been requested

          return this.announceDealRequested(res, placeId);
        },
      });
    }

    announceDealRequested(res, requestedPlaceId) {
      if (this.placeId === requestedPlaceId) {
        return this.$el.trigger('deal-requested', [
          res.data.presentedFollowCount,
        ]);
      }
      return null;
    }
  });
  Cls.initClass();
  return Cls;
})();

$(() => {
  const el = '.request-deal';

  if (!($(el).length > 0)) {
    return null;
  }

  const place = $('.mpp-container').data();
  const radConfig = $(el).data();
  const csrfToken = $('meta[name=csrf-token]').attr('content');
  new Groupon.RequestDeal(
    el,
    csrfToken,
    place.placeId,
    radConfig.nearbyPlacesCount,
    radConfig.showModal
  );
  return new Groupon.SharingButtons({
    el: $('.request-deal .share-links'),
    merchantPage: {
      permalink: window.location.pathname.replace('/biz/', ''),
      merchantName: place.placeName,
      twitterBody: radConfig.twitterBody,
      emailSubject: radConfig.emailSubject,
      emailBody: radConfig.emailBody,
      campaign: 'UserReferral_mpp_rad',
    },
  });
});
